
import React, { Fragment } from 'react'
import { Col } from 'react-bootstrap'
import { Can } from '@casl/react';

import useTranslation from '@/Hooks/UseTranslation'
import { useAuth } from '@/Hooks/UseAuth';

import ButtonAddTeam from '../ButtonAddTeam/ButtonAddTeam';
import LeftTeamSelector from './LeftTeamSelector'

const LeftTeamSide = () => {

  const { t } = useTranslation()

  const { ability } = useAuth()

  return (
    <Col lg={4} xl={3} className="teams-left-side">
      <Fragment>
        <div className='teams-header'>
          <h3>{t('TEAMS:PageTitle')}</h3>
        </div>
        <div className='team-selector-container'>
          <LeftTeamSelector />
          <div className="d-inline-block d-lg-none">
            <Can I="create" a="Team" ability={ability}>
              <ButtonAddTeam className='ml-1' />
            </Can>
          </div>
        </div>
      </Fragment>
    </Col>
  )
}

export default LeftTeamSide
